import apiVersion from '../_helpers/api-version';
import axiosInstance from '../_helpers/axiosConfig'

import { authHeader, axsToken } from '../_helpers/auth-header'
import httpStatus from 'http-status';

export const providerService = {
  getAll,
  getOptions
};

function getOptions() {
  return axiosInstance.request({
    method: 'GET',
    headers: axsToken(),
    url: `${process.env.REACT_APP_API2_URL}/${apiVersion()}/client/options-providers`,
  }).then((response) => {
    if (response && response.status === httpStatus.OK) {
      return response.data.data;
    }
  })
}

function getAll() {
  return axiosInstance.request({
    method: 'GET',
    headers: authHeader(),
    url: `${process.env.REACT_APP_API_URL}/api/${apiVersion()}/provider`,
  }).then((response) => {
    if (response && response.status === httpStatus.OK) {
      return response.data.data;
    }
  })
}